import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, ListGroup, ListGroupItem, Row } from "reactstrap";
import FilterComponent from "../Common/FilterComponent";
import DataTable from "react-data-table-component";
import { H4, P, UL, LI, Badges, Btn } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import ScrollBar from "react-perfect-scrollbar";
import Swal from "sweetalert2";

//Types
import { CompanyContact } from "../../../Types/CompanyProfile/CompanyContact";

//Modal
import CreateContactModal from "../../UiKits/Modal/CompanyContact/Create";
import UpdateContactModal from "../../UiKits/Modal/CompanyContact/Update";

//Services
import {
  COMPCONTACT_QUERY_KEY,
  companycontactService,
} from "../../../Services/companycontactService";

type CompanyDataProps = {
  code?: string;
};

const ContactTable = ({ code }: CompanyDataProps) => {
  const company_code = code || "";
  const [open, setOpen] = useState<string>("1");
  const toggle = (id: string) => (open === id ? setOpen("") : setOpen(id));
  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  const [filterText, setFilterText] = useState("");
  const [CompanyContactmodal, setCompanyContactmodal] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [selectedToggleId, setSelectedToggleId] = useState<number | null>(null);

  const toggleCompContact = (id?: number) => {
    if (id !== undefined) {
      setSelectedId(id);
    }
    setCompanyContactmodal((prev) => !prev);
  };

  const contactQueryKey = [...COMPCONTACT_QUERY_KEY, company_code];

  const { data: ContactData = [], isLoading: isContactLoading } = useQuery<
    CompanyContact[]
  >({
    queryKey: contactQueryKey,
    queryFn: () =>
      companycontactService.getContactByCompany(company_code as string),
  });

  return (
    <Card className="card-absolute">
      <CommonCardHeader
        headClass="bg-primary"
        tagClass="txt-light"
        title={"Contacts"}
      />
      <CardBody>
        <UpdateContactModal
          toggle={() => toggleCompContact()}
          modal={CompanyContactmodal}
          id={selectedId ?? undefined}
        />
        <CreateContactModal company_code={company_code} />
        <ScrollBar
          className="vertical-scroll scroll-b-none"
          style={{ width: "100%", height: "520px" }}
        >
          <ListGroup className="main-lists-content">
            {ContactData &&
              ContactData.map((item, index) => (
                <ListGroupItem
                  action
                  className={"list-hover-primary"}
                  key={index}
                >
                  <div className="border border-0 height-equal">
                    <div className="list-content">
                      <div className="d-flex align-items-center">
                        <Link to="#" onClick={() => toggleCompContact(item.id)}>
                          <H4 className="mb-0">{item.name}</H4>
                        </Link>
                        <Badges
                          badge
                          color={item.status === 1 ? "success" : "danger"}
                          className="ms-auto"
                        >
                          {item.status === 1 ? "ACTIVE" : "INACTIVE"}
                        </Badges>
                      </div>
                      <div className="list-wrapper gap-0">
                        <i className="fa fa-briefcase me-2"></i>
                        <span className="f-light f-w-200 f-12">
                          {item.position}
                        </span>
                      </div>
                      <div className="list-wrapper gap-0">
                        <i className="fa fa-envelope me-2"></i>
                        <span className="f-light f-w-200 f-12">
                          {item.email_address
                            ? item.email_address
                            : "No Record Found"}
                        </span>
                      </div>
                      <div className="list-wrapper gap-0">
                        <span className="f-light f-w-200 f-12">
                          <i className="fa fa-signal me-2"></i>
                          {item.mobile2
                            ? `${item.mobile1} | ${item.mobile2}`
                            : item.mobile1}
                        </span>
                      </div>
                      <div className="list-wrapper gap-0">
                        <span className="f-light f-w-200 f-12">
                          <i className="fa fa-phone me-2"></i>
                          {item.telno1 && item.telno2
                            ? `${item.telno1} | ${item.telno2}`
                            : item.telno1
                              ? item.telno1
                              : item.telno2
                                ? item.telno2
                                : "No Record Found"}
                        </span>
                      </div>
                    </div>
                  </div>
                </ListGroupItem>
              ))}
          </ListGroup>
        </ScrollBar>
      </CardBody>
    </Card>
  );
};

export default ContactTable;
